<div class="full-page w-100 d-md-flex d-block px-lg-0 bg-primary m-0">
  <div
    class="maintenance-page-div d-flex flex-column justify-content-lg-center justify-content-evenly align-items-center w-100 h-100"
  >
    <div class="maintenance-page-logo d-flex align-items-center pb-5">
      <img alt="" class="logo" src="assets/images/logo.png" draggable="false" />
    </div>
    <div class="container">
      <div class="maintenance-page-details d-flex flex-column justify-content-center align-items-center">
        <div class="maintenance-container text-center">
          <div class="icon material-icons text-white">engineering</div>
          <h5 class="maintenance-title text-white mb-0">{{ 'maintenance.page.title' | translate }}</h5>
          <div class="font-size-14 text-white mb-0">{{ 'maintenance.page.details' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
